import { AutoCompleteRemote } from "components/Form"
import { useMemo } from "react"
import { FormatterCell, RemoteOptionColumnModel } from "../../models"
import { GenericFilterModelCollection, IdNameResponseItemsResponseModel, IdNameResponseSimpleResponseModel } from "services/tenantManagementService"

export const emptyItemsResponse = new IdNameResponseItemsResponseModel({
	success: true,
	count: 0,
	items: []
})

type Props = {
	column: RemoteOptionColumnModel<any>
	value: number
	onChange(value: number): void
	onBlur(): void
	loading: boolean
	formatterCell: FormatterCell
}

export const RemoteOptionEditableCell = ({ column, value, onChange, onBlur, loading, formatterCell }: Props) => {
	const specificPropsMemo = useMemo(
		() => {
			const { items, getItemText, getItemStyle, getText, filters } = column;

			return {
				getItemText,
				getItemStyle,
				getText,
				entityPrefix: column.entityPrefix,
				fetchItemsFunction: async (genericFilter: GenericFilterModelCollection, searchValue: string | undefined) => {
					return await column.fetchItemsFunction(genericFilter, searchValue, formatterCell);
				},
				fetchSingleItemFunction: (id: number) => {
					const selectedItem = items.find((item) => item.id === id);
					const model = new IdNameResponseSimpleResponseModel({
						success: true,
						value: selectedItem
					});
					return Promise.resolve(model);
				},
				filters: filters
			}
		},
		[column, formatterCell]
	)

	return (
		<AutoCompleteRemote
			value={value}
			onChange={onChange}
			onBlur={onBlur}
			{...specificPropsMemo}
			size='small'
		/>
	)
}
